const DateTimeField = ({
  label,
  name,
  value,
  now = true,
  compulsory = false,
  formField = false,
  error,
  changeNow,
  checkNow,
  ...props
}) => (
  <div className={`form-group ${formField === true ? "mt-3" : ""}`}>
    <label className="label">
      <span style={{ paddingLeft: formField === true ? "0px" : "8px" }}>
        {label}
      </span>
      {now === true && (
        <span style={{ float: "right", paddingRight: "22%" }}>
          Now{" "}
          <input
            type="checkbox"
            checked={checkNow === 1}
            onChange={changeNow}
            style={{ width: "14px", height: "14px" }}
          />
        </span>
      )}
    </label>
    <div className="flex">
      <input
        type="datetime-local"
        className="input"
        name={name}
        value={value}
        {...props}
      />
      {compulsory && <span className="label-imp">*</span>}
    </div>
    {error && <p className="label-error">{error}</p>}
  </div>
);

export default DateTimeField;
